import { subGraphExpanderImageButton } from '@y42/gojs';
import { Binding, GraphObject, Margin, Panel, Picture, Size, Spot, TextBlock } from 'gojs';
import {
  dataLineageDiagramConfig,
  DataLineageNodeBinding,
  LINEAGE_PARTS,
} from '../../../../../../state/data-lineage-diagram';
import { groupButtons } from '../../shared/parts/buttons/group-buttons';
import { entityTypeLogoTooltip, groupHeaderTextToolTip } from '../../shared/parts/tooltips';
import { logoBinding, nameTextBinding, nameTextStrokeBinding } from '../../shared/utils/shared-bindings';

const $ = GraphObject.make;

export const groupHeader = () =>
  $(
    Panel,
    Panel.Horizontal,
    {
      defaultAlignment: Spot.Left,
      height: 50,
      padding: new Margin(0),
    },
    subGraphExpanderImageButton([]),
    entityLogo([logoBinding()]),
    headerText(),
    groupButtons([new Binding('visible', DataLineageNodeBinding.DeletedEntity, (deletedEntity) => !deletedEntity)]),
  );

const entityLogo = (bindings: Binding[] = []) =>
  $(
    Picture,
    {
      name: LINEAGE_PARTS.GROUP_LOGO_NAME,
      desiredSize: new Size(25, 25),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(0, 5, 0, 5),
      toolTip: entityTypeLogoTooltip(),
    },
    ...bindings,
  );

const headerText = (bindings: Binding[] = []) =>
  $(
    TextBlock,
    {
      name: LINEAGE_PARTS.GROUP_HEADER_NAME,
      alignment: Spot.Left,
      font: `${dataLineageDiagramConfig.font.style} ${dataLineageDiagramConfig.font.size.big} ${dataLineageDiagramConfig.font.family}`,
      overflow: TextBlock.OverflowEllipsis,
      height: 20,
      width: 225,
      toolTip: groupHeaderTextToolTip(),
    },
    nameTextBinding(),
    nameTextStrokeBinding(),
    ...bindings,
  );
